import { AppointmentCategoryEnum } from "@hunkware/shared/types";

export enum CategoryIdEnum {
  Junk = AppointmentCategoryEnum.JunkRemoval,
  Labor = AppointmentCategoryEnum.Labor,
  Moving = AppointmentCategoryEnum.Moving,
}

export enum CategorySlugEnum {
  Junk = "Junk",
  Labor = "Labor",
  Moving = "Moving",
}

export enum CategoryNamesEnum {
  Junk = "Junk Removal",
  Labor = "Labor",
  Moving = "Moving",
}
